<kabas-legals-hero></kabas-legals-hero>

<div class="[ container p-be-3xl stack ]">
  <ng-container *ngIf="slug$ | async as slug">
    <kabas-legals-page-privacy *ngIf="slug === 'privacy'"></kabas-legals-page-privacy>
    <kabas-legals-page-sales-conditions *ngIf="slug === 'verkoopsvoorwaarden'"></kabas-legals-page-sales-conditions>
    <kabas-legals-page-terms-of-use *ngIf="slug === 'gebruiksvoorwaarden'"></kabas-legals-page-terms-of-use>
    <kabas-legals-page-ai *ngIf="slug === 'ai'"></kabas-legals-page-ai>
  </ng-container>
</div>
